<template>
  <div class="teacher">
    <router-view class="router-view" />
  </div>
</template>

<script>
import utils from '@/services/utils';

export default {
  name: 'home',
  created() {
    if (utils.isLogin()) {
      window.location.href = '/#/teacher/student-info';
    } else {
      window.location.href = '/#/teacher/login';
    }
    document.title = '百项过值班系统';
  },
  destroyed() {
    document.title = '百项过学习中心';
  },
};
</script>

<style>
  .teacher{
    width: 100%;
    height: 100%;
  }
</style>
